import React from 'react';
import EditorView from './EditorView';
import DatasheetPreview from './DatasheetPreview';

export default function ProjectEditModal({ editData, setEditData, onCancel, onSave }) {
  return (
    <div className="proj-edit-overlay" data-testid="project-edit-overlay">
      <div className="proj-edit-modal">
        <div className="proj-edit-head">
          <div><strong>Editing project copy</strong><span> · changes here do NOT affect the original datasheet</span></div>
          <div className="proj-edit-actions">
            <button className="btn" onClick={onCancel}>Cancel</button>
            <button className="btn btn-primary" data-testid="project-edit-save" onClick={onSave}>Save to project</button>
          </div>
        </div>
        <div className="proj-edit-body">
          <div className="proj-edit-form"><EditorView sheet={editData} setSheet={setEditData} /></div>
          <div className="proj-edit-preview"><div className="preview-zoom" style={{ transform: 'scale(0.5)' }}><DatasheetPreview sheet={editData} /></div></div>
        </div>
      </div>
    </div>
  );
}
